<template>
    <div>
        124
    </div>
</template>

<script>
import axios from '../../axios-auth.js'
import {mapGetters} from 'vuex'

export default {
    computed: 
        mapGetters([
                ]),
    data() {
        return {
            test_type: 0,
            test_info: null
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
        },
    }
}
</script>